import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface TopProgressState {
  /** Porcentaje de progreso (0–100) */
  progress: number;
  /** Si la barra está visible */
  visible: boolean;
  /** Posición visual (superior o inferior) */
  position: "top" | "bottom";
}

const initialState: TopProgressState = {
  progress: 0,
  visible: false,
  position: "top",
};

export const topProgressSlice = createSlice({
  name: "topProgress",
  initialState,
  reducers: {
    /**
     * 🔹 Muestra la barra en pantalla.
     * @param action "top" o "bottom"
     */
    showTopProgress: (state, action: PayloadAction<"top" | "bottom" | undefined>) => {
      state.visible = true;
      state.position = action.payload || "top";
      state.progress = 0;
    },

    /**
     * 🔹 Actualiza el progreso actual (0–100)
     */
    setTopProgress: (state, action: PayloadAction<number>) => {
      state.progress = Math.min(Math.max(action.payload, 0), 100); // Clamp 0–100
      if (state.progress > 0) state.visible = true; // Auto-activar si está avanzando
    },

    /**
     * 🔹 Oculta completamente la barra y reinicia estado
     */
    hideTopProgress: (state) => {
      state.visible = false;
      state.progress = 0;
    },

    /**
     * 🔄 Reinicia sin afectar la visibilidad
     */
    resetTopProgress: (state) => {
      state.progress = 0;
    },
  },
});

export const {
  showTopProgress,
  setTopProgress,
  hideTopProgress,
  resetTopProgress,
} = topProgressSlice.actions;

export default topProgressSlice.reducer;
